import jQuery from 'jquery'

const onLoad = () => {
  let showFlag = false
  let topBtn = jQuery('#to-page-top')
  topBtn.css('bottom', '-100px')
  topBtn.show()
  //スクロールが100に達したらボタン表示
  jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 100) {
      if (!showFlag) {
        showFlag = true
        topBtn.stop().animate({'bottom' : '50px'}, 200)
      }
    } else {
      if (showFlag) {
        showFlag = false
        topBtn.stop().animate({'bottom' : '-100px'}, 200)
      }
    }
  })
  //スクロールしてトップ
  topBtn.click(function () {
    jQuery('body,html').animate({
      scrollTop: 0
    }, 500)
    return false
  })
}
export default function() {
  jQuery(onLoad)
}
